import { useCallback, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import { connect } from "react-redux";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import { setUser } from "../../../store/action/auth";
import HttpService from "../../../services/http_service/HttpService";
import Http from "../../../services/http/Http";
import WarningAlert from "../../../components/alert/Warning";
import Stack from "../../../components/stack";
import Item from "./Item";
import CreateAddress from "./create";
import Loading from "./loading";
import { Div } from "./style";
import Empty from "./empty";

const Address = (props) => {
  const history = useHistory();

  const createAddressRef = useRef();

  const { user } = props;

  const [isLoadingGetData, setIsLoadingGetData] = useState(false);
  const [addresses, setAddresses] = useState([]);

  const getAddresses = useCallback(() => {
    setIsLoadingGetData(true);

    HttpService(user?.token)
      .get("user/addresses")
      .then((response) => {
        setAddresses(response.data?.entity?.addresses);
      })
      .catch((error) => {
        Http(error?.response?.status, error?.response?.data?.message, props);
      })
      .finally(() => {
        setIsLoadingGetData(false);
      });
  }, [user, props]);

  useEffect(() => {
    getAddresses();
  }, [getAddresses]);

  const handleBack = () => {
    history.goBack();
  };

  return (
    <>
      <CreateAddress
        refrence={createAddressRef}
        addresses={addresses}
        setAddresses={setAddresses}
      />
      <Stack
        title="آدرس ها"
        handleChangeStatus={handleBack}
        headerLeft={() => (
          <IconButton
            color="inherit"
            onClick={() => createAddressRef.current.changeStatus()}
          >
            <AddIcon />
          </IconButton>
        )}
      />
      <Div className="mx-1 mt-2">
        <WarningAlert className="f-12 px-1 py-2 mb-2">
          برای ویرایش آدرس رو به سمت راست و برای حذف به سمت چپ بکشید.
        </WarningAlert>
        {isLoadingGetData ? (
          <Loading />
        ) : (
          <>
            {addresses.length ? (
              addresses.map((address, index) => (
                <Item
                  key={index}
                  data={address}
                  addresses={addresses}
                  setAddresses={setAddresses}
                />
              ))
            ) : (
              <Empty addresses={addresses} setAddresses={setAddresses} />
            )}
          </>
        )}
      </Div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
  };
};

export default connect(mapStateToProps, { setUser })(Address);
